export const mutations = {
  SET_INSURERS (state, { insurers }) {
    state.insurers = insurers
  },
  SET_PACKAGES (state, { packages }) {
    state.packages = packages
  }
}
